import { MouseEvent, ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react'
import { cn } from '@bem-react/classname'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Memo } from '@/hoc/Memo'

import './Back.scss'

const cnBack = cn('Back')

export interface BackSchema
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  push?: string
  textBack?: string
  isTextBack?: boolean
  isIndentBottom?: boolean
}

export const Back: FC<BackSchema> = Memo(
  ({
    onClick,
    className,
    push,
    textBack = 'Back',
    isTextBack = true,
  }: BackSchema) => {
    const { t } = useTranslation('translation')
    const navigate = useNavigate()

    const onGoTo = (e: MouseEvent<HTMLButtonElement>) => {
      if (onClick) {
        onClick && onClick(e)
      } else {
        push ? navigate(push) : navigate(-1)
      }
    }

    return (
      <button className={cnBack(null, [className])} onClick={onGoTo}>
        <i className='fa-solid fa-chevron-left'></i>
        {isTextBack && t(textBack)}
      </button>
    )
  },
)
